var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.hasValue
        ? _c("file-item", {
            key: _vm.url,
            attrs: { removable: "", metadata: _vm.metadata, url: _vm.url },
            on: {
              remove: function ($event) {
                return _vm.emit(null)
              },
            },
          })
        : _c("file-source", { on: { input: _vm.emit } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }